import { render, staticRenderFns } from "./StudentFreeSituationRead.vue?vue&type=template&id=138f780d&scoped=true"
import script from "./StudentFreeSituationRead.vue?vue&type=script&lang=js"
export * from "./StudentFreeSituationRead.vue?vue&type=script&lang=js"
import style0 from "./StudentFreeSituationRead.vue?vue&type=style&index=0&id=138f780d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f780d",
  null
  
)

export default component.exports